<app-project-base
  [project]="project"
  [datasetTiles]="datasetTiles"
  [resourceTiles]="resourceTiles"
  [metaTableData]="metaTableData"
  [showSidebar]="false"
>
</app-project-base>
